// Fade + slide reveal for nix sections as they scroll into view. Loaded
// synchronously in head: the .nix-anim gate is what switches the hidden-until-
// revealed CSS on, so a failed request leaves the page visible.
// Selector list is mirrored in nix-app.css — keep the two in sync. Carousel
// slides are excluded: the ones parked off to the side never intersect.
const NIX_REVEAL_SELECTOR = [
  '#MainContent .nix-container:not(.nix-carousel-slide__content) > *',
  '.nix-footer__container > *',
  '#MainContent .shopify-section:not(:has(.nix-container))',
].join(', ');

const NIX_REVEAL_STAGGER = 90;
const NIX_REVEAL_MAX_STEPS = 4;

let nixRevealObserver;

function onNixReveal(entries, observer) {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    entry.target.classList.add('nix-revealed');
    observer.unobserve(entry.target);
  });
}

function initNixReveal(root = document) {
  nixRevealObserver ||= new IntersectionObserver(onNixReveal);

  const targets = [...root.querySelectorAll(NIX_REVEAL_SELECTOR)];
  if (root !== document && root.matches(NIX_REVEAL_SELECTOR)) targets.push(root);

  targets.forEach((target) => {
    const parent = target.parentElement;
    const index = parent.matches('.nix-container, .nix-footer__container') ? [...parent.children].indexOf(target) : 0;

    target.style.setProperty('--nix-reveal-delay', `${Math.min(index, NIX_REVEAL_MAX_STEPS) * NIX_REVEAL_STAGGER}ms`);
    nixRevealObserver.observe(target);
  });
}

if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.documentElement.classList.add('nix-anim');
  document.addEventListener('DOMContentLoaded', () => initNixReveal());

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.closest('#MainContent')) initNixReveal(event.target);
    });
  }
}
